import script from "./UserAvartar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvartar.vue?vue&type=script&setup=true&lang=js"

import "./UserAvartar.vue?vue&type=style&index=0&id=3097f4bb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3097f4bb"]])

export default __exports__